<div *ngIf="showResults" class="container-fluid">
    <div class="row">
        <app-summary-section></app-summary-section>
        <app-results-charts *ngIf="showCharts"></app-results-charts>
        <app-results-grid></app-results-grid>
    </div>
</div>

